export const stringHelper = {
    upperCapital,
};

function upperCapital(string) 
{
    return string.charAt(0).toUpperCase() + string.slice(1);
}